import { SVGProps } from '../type'
import * as SparkIcons from './List'
import { ArrowReplaceImage } from './List/ArrowReplaceImage'

export const sparkIcons = {
  'live-engagements': (props: SVGProps) => <SparkIcons.LiveEngagementsIcon {...props} />,
  programs: (props: SVGProps) => <SparkIcons.ProgramsIcon {...props} />,
  performance: (props: SVGProps) => <SparkIcons.PerformanceIcon {...props} />,
  'light-bulb-custom': (props: SVGProps) => <SparkIcons.LightBulbCustomIcon {...props} />,
  plans: (props: SVGProps) => <SparkIcons.PlanIcon {...props} />,
  engagements: (props: SVGProps) => <SparkIcons.EngagementsIcon {...props} />,
  'chevron-down-custom': (props: SVGProps) => <SparkIcons.ChevronDownCustomIcon {...props} />,
  'chevron-up-custom': (props: SVGProps) => <SparkIcons.ChevronUpCustomIcon {...props} />,
  award: (props: SVGProps) => <SparkIcons.AwardIcon {...props} />,
  clock: (props: SVGProps) => <SparkIcons.ClockIcon {...props} />,
  response: (props: SVGProps) => <SparkIcons.ResponseIcon {...props} />,
  link: (props: SVGProps) => <SparkIcons.LinkIcon {...props} />,
  camera: (props: SVGProps) => <SparkIcons.CameraIcon {...props} />,
  'check-verified-2': (props: SVGProps) => <SparkIcons.CheckVerified2 {...props} />,
  audit: (props: SVGProps) => <SparkIcons.CheckVerified2 {...props} />,
  'view-grid': (props: SVGProps) => <SparkIcons.ViewGridIcon {...props} />,
  'view-list': (props: SVGProps) => <SparkIcons.ViewListIcon {...props} />,
  task: (props: SVGProps) => <SparkIcons.TaskIcon {...props} />,
  signal: (props: SVGProps) => <SparkIcons.SignalIcon {...props} />,
  trash: (props: SVGProps) => <SparkIcons.TrashIcon {...props} />,
  'exclamation-circle': (props: SVGProps) => <SparkIcons.ExclamationCircleIcon {...props} />,
  'exclamation-circle-colorful': (props: SVGProps) => <SparkIcons.ExclamationCircleColorfulIcon {...props} />,
  'activity-circle': (props: SVGProps) => <SparkIcons.ActivityCircleIcon {...props} />,
  'check-circle': (props: SVGProps) => <SparkIcons.CheckCircleIcon {...props} />,
  robot: (props: SVGProps) => <SparkIcons.RobotIcon {...props} />,
  'sorting-list': (props: SVGProps) => <SparkIcons.SortingListIcon {...props} />,
  check: (props: SVGProps) => <SparkIcons.CheckIcon {...props} />,
  reply: (props: SVGProps) => <SparkIcons.ReplyIcon {...props} />,
  speed: (props: SVGProps) => <SparkIcons.SpeedIcon {...props} />,
  copy: (props: SVGProps) => <SparkIcons.CopyIcon {...props} />,
  close: (props: SVGProps) => <SparkIcons.CloseIcon {...props} />,
  exclamation: (props: SVGProps) => <SparkIcons.ExclamationIcon {...props} />,
  'exclamation-colorful': (props: SVGProps) => <SparkIcons.ExclamationColorfulIcon {...props} />,
  information: (props: SVGProps) => <SparkIcons.InformationIcon {...props} />,
  correction: (props: SVGProps) => <SparkIcons.CorrectionIcon {...props} />,
  annotation: (props: SVGProps) => <SparkIcons.AnnotationIcon {...props} />,
  'dot-vertical': (props: SVGProps) => <SparkIcons.DotVerticalIcon {...props} />,
  'arrow-short-up': (props: SVGProps) => <SparkIcons.ArrowUpIcon {...props} />,
  'arrow-short-down': (props: SVGProps) => <SparkIcons.ArrowDownIcon {...props} />,
  'arrow-short-right': (props: SVGProps) => <SparkIcons.ArrowRightIcon {...props} />,
  'indicate-row': (props: SVGProps) => <SparkIcons.IndicateRowIcon {...props} />,
  message: (props: SVGProps) => <SparkIcons.MessageIcon {...props} />,
  'eye-off': (props: SVGProps) => <SparkIcons.EyeOffIcon {...props} />,
  eye: (props: SVGProps) => <SparkIcons.EyeIcon {...props} />,
  saturation: (props: SVGProps) => <SparkIcons.SaturationIcon {...props} />,
  contrast: (props: SVGProps) => <SparkIcons.ContrastIcon {...props} />,
  restore: (props: SVGProps) => <SparkIcons.RestoreIcon {...props} />,
  accuracy: (props: SVGProps) => <SparkIcons.AccuracyIcon {...props} />,
  difficult: (props: SVGProps) => <SparkIcons.DifficultIcon {...props} />,
  plus: (props: SVGProps) => <SparkIcons.PlusIcon {...props} />,
  'step-start': (props: SVGProps) => <SparkIcons.StepStartIcon {...props} />,
  'step-end': (props: SVGProps) => <SparkIcons.StepEndIcon {...props} />,
  'step-middle': (props: SVGProps) => <SparkIcons.StepMiddleIcon {...props} />,
  'double-dot-vertical': (props: SVGProps) => <SparkIcons.DoubleDotVerticalIcon {...props} />,
  'close-transparent-circle': (props: SVGProps) => <SparkIcons.CloseTransparentCircleIcon {...props} />,
  'check-transparent-circle': (props: SVGProps) => <SparkIcons.CheckTransparentCircleIcon {...props} />,
  'check-colorful-circle': (props: SVGProps) => <SparkIcons.CheckColorfulCircleIcon {...props} />,
  'close-colorful-circle': (props: SVGProps) => <SparkIcons.CloseColorfulCircleIcon {...props} />,
  'message-check': (props: SVGProps) => <SparkIcons.MessageCheckIcon {...props} />,
  'message-x-circle': (props: SVGProps) => <SparkIcons.MessageXCircleIcon {...props} />,
  'message-reject': (props: SVGProps) => <SparkIcons.MessageRejectIcon {...props} />,
  'clock-timeout': (props: SVGProps) => <SparkIcons.ClockTimeoutIcon {...props} />,
  'clock-snooze': (props: SVGProps) => <SparkIcons.ClockSnoozeIcon {...props} />,
  comment: (props: SVGProps) => <SparkIcons.CommentIcon {...props} />,
  bounding_box: (props: SVGProps) => <SparkIcons.BoundingBoxIcon {...props} />,
  polygon: (props: SVGProps) => <SparkIcons.PolygonIcon {...props} />,
  polyline: (props: SVGProps) => <SparkIcons.PolylineIcon {...props} />,
  keypoint: (props: SVGProps) => <SparkIcons.KeypointIcon {...props} />,
  dot: (props: SVGProps) => <SparkIcons.Dot {...props} />,
  single_choice_classification: (props: SVGProps) => <SparkIcons.SingleChoiceClassificationIcon {...props} />,
  multi_choice_classification: (props: SVGProps) => (
    <SparkIcons.MultipleChoiceClassificationIcon {...props} />
  ),
  text_classification: (props: SVGProps) => <SparkIcons.TextClassificationIcon {...props} />,
  pencil: (props: SVGProps) => <SparkIcons.PencilIcon {...props} />,
  'data-flow': (props: SVGProps) => <SparkIcons.DataFlowIcon {...props} />,
  radio_input: (props: SVGProps) => <SparkIcons.RadioInputIcon {...props} />,
  checkbox_input: (props: SVGProps) => <SparkIcons.CheckboxInputIcon {...props} />,
  star_colorful: (props: SVGProps) => <SparkIcons.StarColorfulIcon {...props} />,
  star: (props: SVGProps) => <SparkIcons.StarIcon {...props} />,
  profile: (props: SVGProps) => <SparkIcons.UserIcon {...props} />,
  avatar: (props: SVGProps) => <SparkIcons.AvatarIcon {...props} />,
  upload: (props: SVGProps) => <SparkIcons.UploadIcon {...props} />,
  phone: (props: SVGProps) => <SparkIcons.PhoneIcon {...props} />,
  zoom: (props: SVGProps) => <SparkIcons.ZoomIcon {...props} />,
  'logo-text': (props: SVGProps) => <SparkIcons.LogoWithTextIcon {...props} />,
  'logo-colorful': (props: SVGProps) => <SparkIcons.LogoColorfulIcon {...props} />,
  'loading-spinner': (props: SVGProps) => <SparkIcons.LoadingSpinner {...props} />,
  'message-question-circle': (props: SVGProps) => <SparkIcons.MessageQuestionCircleIcon {...props} />,
  'message-check-circle': (props: SVGProps) => <SparkIcons.MessageCheckCircleIcon {...props} />,
  passcode: (props: SVGProps) => <SparkIcons.PasscodeIcon {...props} />,
  scan: (props: SVGProps) => <SparkIcons.ScanIcon {...props} />,
  okta: (props: SVGProps) => <SparkIcons.OktaIcon {...props} />,
  'external-link': (props: SVGProps) => <SparkIcons.ExternalLinkIcon {...props} />,
  refresh: (props: SVGProps) => <SparkIcons.RefreshIcon {...props} />,
  gamma: (props: SVGProps) => <SparkIcons.GammaIcon {...props} />,
  move: (props: SVGProps) => <SparkIcons.MoveIcon {...props} />,
  cross: (props: SVGProps) => <SparkIcons.CrossIcon {...props} />,
  expand: (props: SVGProps) => <SparkIcons.ExpandIcon {...props} />,
  keyboard: (props: SVGProps) => <SparkIcons.KeyboardIcon {...props} />,
  flag: (props: SVGProps) => <SparkIcons.FlagIcon {...props} />,
  ban: (props: SVGProps) => <SparkIcons.BanIcon {...props} />,
  image: (props: SVGProps) => <SparkIcons.ImageIcon {...props} />,
  'accuracy-v2': (props: SVGProps) => <SparkIcons.AccuracyV2Icon {...props} />,
  'tick-list': (props: SVGProps) => <SparkIcons.TickListIcon {...props} />,
  spark: (props: SVGProps) => <SparkIcons.SparkIcon {...props} />,
  instruction: (props: SVGProps) => <SparkIcons.InstructionIcon {...props} />,
  terminal: (props: SVGProps) => <SparkIcons.TerminalIcon {...props} />,
  location: (props: SVGProps) => <SparkIcons.LocationIcon {...props} />,
  menu: (props: SVGProps) => <SparkIcons.MenuIcon {...props} />,
  x: (props: SVGProps) => <SparkIcons.XIcon {...props} />,
  logout: (props: SVGProps) => <SparkIcons.LogoutIcon {...props} />,
  globe: (props: SVGProps) => <SparkIcons.GlobeIcon {...props} />,
  share: (props: SVGProps) => <SparkIcons.ShareIcon {...props} />,
  api: (props: SVGProps) => <SparkIcons.ApiIcon {...props} />,
  'arrow-replace-image': (props: SVGProps) => <ArrowReplaceImage {...props} />,
  'pencil-alt': (props: SVGProps) => <SparkIcons.PencilAltIcon {...props} />,
  'thumbs-up': (props: SVGProps) => <SparkIcons.ThumbsUpIcon {...props} />,
  'dot-horizontal': (props: SVGProps) => <SparkIcons.DotHorizontalIcon {...props} />,
  'thumbs-up-filled': (props: SVGProps) => <SparkIcons.ThumbsUpFilledIcon {...props} />,
  'flag-filled': (props: SVGProps) => <SparkIcons.FlagFilledIcon {...props} />,
  underline: (props: SVGProps) => <SparkIcons.UnderlineIcon {...props} />,
  'strike-through': (props: SVGProps) => <SparkIcons.StrikeThroughIcon {...props} />,
  italic: (props: SVGProps) => <SparkIcons.ItalicIcon {...props} />,
  bold: (props: SVGProps) => <SparkIcons.BoldIcon {...props} />,
  send: (props: SVGProps) => <SparkIcons.SendIcon {...props} />,
  benchmark: (props: SVGProps) => <SparkIcons.BenchmarkIcon {...props} />,
  chat: (props: SVGProps) => <SparkIcons.ChatIcon {...props} />,
  certificate: (props: SVGProps) => <SparkIcons.CertificateIcon {...props} />,
  'document-search': (props: SVGProps) => <SparkIcons.DocumentSearchIcon {...props} />,
  'lock-closed': (props: SVGProps) => <SparkIcons.LockClosedIcon {...props} />,
  collection: (props: SVGProps) => <SparkIcons.CollectionIcon {...props} />,
  'check-circle-broken': (props: SVGProps) => <SparkIcons.CheckCircleBrokenIcon {...props} />,
  'slash-circle': (props: SVGProps) => <SparkIcons.SlashCircleIcon {...props} />,
  'alert-triangle': (props: SVGProps) => <SparkIcons.AlertTriangleIcon {...props} />,
  'user-add': (props: SVGProps) => <SparkIcons.UserAddIcon {...props} />,
  selector: (props: SVGProps) => <SparkIcons.SelectorIcon {...props} />,
  'office-building': (props: SVGProps) => <SparkIcons.OfficeBuildingIcon {...props} />,
  chip: (props: SVGProps) => <SparkIcons.ChipIcon {...props} />,
  database: (props: SVGProps) => <SparkIcons.DatabaseIcon {...props} />,
  'globe-alt': (props: SVGProps) => <SparkIcons.GlobeAltIcon {...props} />,
  clipboard: (props: SVGProps) => <SparkIcons.ClipboardIcon {...props} />,
  'arrow-narrow-left': (props: SVGProps) => <SparkIcons.ArrowNarrowLeft {...props} />,
  fire: (props: SVGProps) => <SparkIcons.FireIcon {...props} />,
  'read-more': (props: SVGProps) => <SparkIcons.ReadMoreIcon {...props} />,
  'surge-alert': (props: SVGProps) => <SparkIcons.SurgeAlertIcon {...props} />,
  'exclamation-point': (props: SVGProps) => <SparkIcons.ExclamationPointIcon {...props} />,
  'exclamation-circle-status': (props: SVGProps) => <SparkIcons.ExclamationCircleStatusIcon {...props} />,
  rejected: (props: SVGProps) => <SparkIcons.RejectedIcon {...props} />,
  'cursor-click': (props: SVGProps) => <SparkIcons.CursorClickIcon {...props} />,
  'avatar-empty': (props: SVGProps) => <SparkIcons.AvatarEmptyIcon {...props} />,
  controls: (props: SVGProps) => <SparkIcons.ControlsIcon {...props} />,
  'increasing-bars': (props: SVGProps) => <SparkIcons.IncreasingBarsIcon {...props} />,
  'time-passing': (props: SVGProps) => <SparkIcons.TimePassingIcon {...props} />,
  'simple-exclamation': (props: SVGProps) => <SparkIcons.SimpleExclamationIcon {...props} />,
  'image-upload': (props: SVGProps) => <SparkIcons.ImageUploadIcon {...props} />,
  document: (props: SVGProps) => <SparkIcons.DocumentIcon {...props} />,
  brackets: (props: SVGProps) => <SparkIcons.BracketsIcon {...props} />,
  'upload-alt': (props: SVGProps) => <SparkIcons.UploadAlt {...props} />,
  'cloud-upload': (props: SVGProps) => <SparkIcons.CloudUpload {...props} />,
}
